import React from "react";
import type { ClassSessionsDetailResponse } from "../../../interfaces/classSessionsDetail";
import { useLocalization } from "../../../stores/localizationContext";
import "./ClassSessionsHeader.scss";

interface ClassSessionsHeaderProps {
  data: ClassSessionsDetailResponse;
}

const ClassSessionsHeader: React.FC<ClassSessionsHeaderProps> = ({ data }) => {
  const { t } = useLocalization();

  const subject = data.class_subjects?.[0];
  const subjectName = subject?.subject_name || data.class_title;
  const subjectColor = subject?.subject_color || "#026bb0";

  const gradeName = subject?.grade_localization_code
    ? t(subject.grade_localization_code, subject.grade_localization_code)
    : "";

  const semesterLabel = data.class_semester_localization_key
    ? t(data.class_semester_localization_key, data.class_semester_localization_key)
    : "";

  const classType = data.class_type || "";

  const subtitleParts = [gradeName, semesterLabel, classType].filter(Boolean);

  return (
    <div className="class-sessions-header">
      <div className="class-sessions-header__banner" />

      <div className="class-sessions-header__content">
        <div
          className="class-sessions-header__icon-wrapper"
          style={{ borderColor: subjectColor }}
        >
          <img
            src={subject?.subject_icon}
            alt={subjectName}
            className="class-sessions-header__icon-image"
          />
        </div>

        <h1 className="class-sessions-header__title" dir="auto">{data.class_title}</h1>

        {subtitleParts.length > 0 && (
          <p className="class-sessions-header__subtitle" dir="auto">
            {subtitleParts.join(" \u2022 ")}
          </p>
        )}
      </div>
    </div>
  );
};

export default ClassSessionsHeader;
